import React, { Component, useState, useEffect, useCallback, useRef, forwardRef, useImperativeHandle  } from 'react';
import {
  useNavigate,
  useLocation,
  Link
} from 'react-router-dom';
import { withTranslation, Translation, } from 'react-i18next';
import i18n from "../../i18n";

import { View, Text, Image, ActivityIndicator} from "react-native-web";

//import { useCartStore } from "../../store/cartStore";

import HamburgerMenu from 'react-hamburger-menu';

import SearchBoxTablet from "./SearchBoxTablet";

import userStore from '../../store/userStore';


const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;


const HeaderTablet = forwardRef((props, ref) => {

  const [searchWidth, setSearchWidth] = useState(0);

  const [open, setOpen] = useState(false);
  const openRef = useRef(false);
  //const [items, setItems] = useState(useCartStore.getState().items);

  const currentYear = new Date().getFullYear();
   const navigate = useNavigate();

   const location = useLocation();

   const isRoot = location.pathname === '/';
   const isHome = location.pathname === '/home';
   const isAbout = location.pathname === '/about';

   let pathname = location.pathname;


   let _user = null, thumbnailURL = '';
   if (props.isSignedin)
   {
      _user = JSON.parse(props.sinUser);

     thumbnailURL = _user.thumbnail;
   }


   const [thumbnail, setThumbnail] = useState(thumbnailURL);


   const user = _user;


  const uniqueItemsCount = 0;// useCartStore((state) => state.items.length);


  const handleNewUserURLStore = useCallback((url) => {
    setThumbnail(url)
    // ... logique de traitement ici
  //  alert('Handling reaction store update:' + JSON.stringify(h));
  }, []);

  useEffect(() => {
    // Enregistrement du handler
    userStore.getState().registerHandler(handleNewUserURLStore);

    // Nettoyage au démontage
    return () => {
      userStore.getState().unregisterHandler?.(handleNewUserURLStore);
    };
  }, [handleNewUserURLStore]);


   const signOut = () => {

     localStorage.removeItem('storrypagejwtToken');
     localStorage.removeItem('storrypageUser');

     setTimeout(() => {
        window.location = "/";
     },100);


   }


   const handleClick = () => {

       let bool;
       if (global.headerBool ===  true)
       {
          bool = false;
          openRef.current = false;
          global.headerBool = false;
       }
       else
       {
          bool = true;
          openRef.current = true;
          global.headerBool = true;
       }

       //let bool = !openRef.current;
       setOpen(bool);



       props.handleMenuClick(bool);
   }


   useImperativeHandle(ref, () => ({
       closeMenu: () => {


           setOpen(false);

           openRef.current = false;
           global.headerBool = false;
          // props.handleMenuClick(false);


       }
   }));

   const setLocale = (lang) => {

          localStorage.setItem("language", lang);
          i18n.changeLanguage(lang);

   }


   const handleSearchChange = (query, objects) => {
      props.handleSearchChange(query, objects);
   }


    return (

      <div className="main_header" style={{top: 0, left: 0, right: 0, width: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)'}}>
           {props.isSignedin &&
                <div className="main_header_inside">

                <div className="main_header_inside_left" style={{marginTop: '5px'}}>
                   <a href="/"><img src={'/img/storrypage_logo_trans.png'} alt="StorryPage Logo" style={{width: '150px'}}/></a>
                </div>


                <div className="main_header_inside_left_2" style={{lineHeight: '65px'}}>
                    <a href="/" style={{fontSize: '17px', fontWeight: isRoot ? 'bold':'normal'}}>{i18n.t('Home')}</a>
                    <a href="/about" style={{fontSize: '17px', fontWeight: isAbout ? 'bold':'normal'}}>{i18n.t('About')}</a>
                 </div>









                <div className="main_header_inside_right_1" style={{ marginRight: '10px', position: 'relative',  display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>

                    <a href="/myaccount">
                       <View style={{cursor: 'pointer', marginLeft: '10px', width: '48px', height: '48px', justifyContent: 'center'}}>
                          {user !== null && <Image source={{uri: thumbnail}} style={{width: '48px', height: '48px', borderRadius: '24px', border: '1px solid #999'}}/>}
                      </View>
                    </a>


                    <View style={{cursor: 'pointer', marginLeft: '40px', marginTop: '0px', width: '48px', height: '48px', justifyContent: 'center'}}>
                    <HamburgerMenu
                      isOpen={openRef.current}
                      menuClicked={handleClick}
                      width={48}
                      height={30}
                      strokeWidth={2}
                      rotate={0}
                      color='#0b49ff'
                      borderRadius={0}
                      animationDuration={0.5}
                     />
                     </View>


                </div>





                <div className="main_header_inside_right_1" style={{fontSize: '1.3rem', float: 'right', marginRight: '15px', lineHeight: '55px', color: '#333', fontFamily: 'Roboto'}}>
                  {i18n.language == 'fr' &&
                     <div style={{textAlign: 'right'}}><a onClick={() => setLocale("en")} style={{color: '#0b49ff'}}>EN</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a onClick={() => setLocale("fr")} style={{color: '#0b49ff'}}>FR</a></div>
                  }
                  {i18n.language == 'en' &&
                     <div style={{textAlign: 'right'}}><a onClick={() => setLocale("en")} style={{color: '#0b49ff'}}>EN</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a onClick={() => setLocale("fr")} style={{color: '#0b49ff'}}>FR</a></div>
                  }
                </div>



                  <div className="main_header_inside_left_2" style={{display: 'none', width: '70%'}}>
                       <a href="/dplay" className="nonactiveHeaderLink">DPlay</a>
                      <a href="/about/dshop" className="nonactiveHeaderLink">DShop</a>
                      <a href="/about/dchat" className="nonactiveHeaderLink">DChat</a>
                      <a href="https://www.yinitj.com/" target="_blank" className="nonactiveHeaderLink">Youth&nbsp;Initiative&nbsp;Jeunesse</a>
                  </div>



                  <div className="main_header_inside_right_1" style={{display: 'none', position: 'relative', width: '346px', flexDirection: 'row', justifyContent: 'flex-end'}}>

                     {uniqueItemsCount > 0 &&
                       <div style={{position: 'absolute', zIndex: 3, left: '68px', backgroundColor: 'red', color: '#fff', fontSize: '16px', fontWeight: 'bold', borderRadius: '13px', minWidth: '32px', height: '26px', lineHeight: '26px', textAlign: 'center'}}>
                          {uniqueItemsCount}
                       </div>
                     }

                      <a href="/cart">
                         <View style={{cursor: 'pointer', marginTop: '5px', width: '44px', height: '44px', justifyContent: 'center'}}>
                            <Image source={{uri: 'https://s3.us-east-1.amazonaws.com/debyooinc20.img/yeqola/cart_empty_white.png'}} style={{width: '44px', height: '44px',}}/>
                         </View>
                       </a>


                       <a href="/signin">
                          <View style={{display: 'none', marginLeft: '40px', marginTop: '5px', backgroundColor: '#fff', width: '120px', height: '44px', justifyContent: 'center', borderRadius: '4px',
                              borderWidth: 1, borderColor: '#fff'}}>
                             {i18n.language == 'en' && <Text style={{fontSize: '17px', color: '#000', textAlign: 'center', fontFamily: 'Mohave',}}>{`Sign in`}</Text>}
                             {i18n.language == 'fr' && <Text style={{fontSize: '17px', color: '#000', textAlign: 'center', fontFamily: 'Mohave',}}>{`Se connecter`}</Text>}
                          </View>
                        </a>

                      <a href="/signup">
                        <View style={{display: 'none', marginLeft: '20px', marginTop: '5px', width: '120px', height: '44px', justifyContent: 'center', borderRadius: '4px',
                                   borderWidth: 1, borderColor: '#fff'}}>
                            {i18n.language == 'en' && <Text style={{fontSize: '17px', color: '#fff', textAlign: 'center', fontFamily: 'Mohave',}}>{`Sign up`}</Text>}
                            {i18n.language == 'fr' && <Text style={{fontSize: '17px', color: '#fff', textAlign: 'center', fontFamily: 'Mohave',}}>{`S'enregistrer`}</Text>}
                        </View>
                     </a>


                     <div className="main_header_inside_right_1" style={{fontSize: '1.3rem', float: 'right', marginRight: '25px', lineHeight: '55px', color: '#fff'}}>
                       {i18n.language == 'fr' &&
                          <div style={{textAlign: 'right'}}><a onClick={() => setLocale("en")} style={{cursor: 'pointer', color: '#fff'}}>EN</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a onClick={() => setLocale("fr")} style={{cursor: 'pointer', color: '#fff'}}>FR</a></div>
                       }
                       {i18n.language == 'en' &&
                          <div style={{textAlign: 'right'}}><a onClick={() => setLocale("en")} style={{cursor: 'pointer', color: '#fff'}}>EN</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a onClick={() => setLocale("fr")} style={{cursor: 'pointer', color: '#fff'}}>FR</a></div>
                       }
                     </div>






                     <a href="/myaccount">
                        <View style={{cursor: 'pointer', marginLeft: '30px', marginTop: '3px', width: '48px', height: '48px', justifyContent: 'center'}}>
                           {user !== null && <Image source={{uri: user.thumbnail}} style={{width: '48px', height: '48px', borderRadius: '24px', border: '1px solid #999'}}/>}
                       </View>
                     </a>





                      <View style={{cursor: 'pointer', marginLeft: '30px', marginTop: '4px', width: '48px', height: '48px', justifyContent: 'center'}}>
                                 <HamburgerMenu
                                   isOpen={openRef.current}
                                   menuClicked={handleClick}
                                   width={48}
                                   height={30}
                                   strokeWidth={2}
                                   rotate={0}
                                   color='#0b49ff'
                                   borderRadius={0}
                                   animationDuration={0.5}
                                  />
                       </View>


                  </div>


                  <div className="main_header_inside_right_1" style={{float: 'right', marginTop: 0, color: '#333'}}>
                      <SearchBoxTablet handleSearchChange={handleSearchChange}/>
                  </div>


                  <div style={{clear: 'both'}}/>

                </div>
            }

            {!props.isSignedin &&
                 <div className="main_header_inside">

                   <div className="main_header_inside_left" style={{marginTop: '5px'}}>
                      <a href="/"><img src={'/img/storrypage_logo_trans.png'} alt="StorryPage Logo" style={{width: '150px'}}/></a>
                   </div>


                   <div className="main_header_inside_left_2" style={{lineHeight: '65px'}}>
  										 <a href="/" style={{fontSize: '17px', fontWeight: isRoot ? 'bold':'normal'}}>{i18n.t('Home')}</a>
                       {viewportWidth > viewportHeight && <a href="/about" style={{fontSize: '17px', fontWeight: isAbout ? 'bold':'normal'}}>{i18n.t('About')}</a>}
  									</div>

                   <div className="main_header_inside_left_2" style={{display: 'none', width: '70%'}}>
                        <a href="/dplay" className="nonactiveHeaderLink">DPlay</a>
                       <a href="/about/dshop" className="nonactiveHeaderLink">DShop</a>
                       <a href="/about/dchat" className="nonactiveHeaderLink">DChat</a>
                       <a href="https://www.yinitj.com/" target="_blank" className="nonactiveHeaderLink">Youth&nbsp;Initiative&nbsp;Jeunesse</a>
                   </div>



                   <div className="main_header_inside_right_1" style={{fontSize: '1.3rem', float: 'right', marginRight: '15px', lineHeight: '55px', color: '#333', fontFamily: 'Roboto'}}>
                     {i18n.language == 'fr' &&
                        <div style={{textAlign: 'right'}}><a onClick={() => setLocale("en")} style={{color: '#0b49ff'}}>EN</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a onClick={() => setLocale("fr")} style={{color: '#0b49ff'}}>FR</a></div>
                     }
                     {i18n.language == 'en' &&
                        <div style={{textAlign: 'right'}}><a onClick={() => setLocale("en")} style={{color: '#0b49ff'}}>EN</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a onClick={() => setLocale("fr")} style={{color: '#0b49ff'}}>FR</a></div>
                     }
                   </div>


                   <div className="main_header_inside_right_1" style={{display: (location.pathname !== '/signin' && location.pathname !== '/signup') ? 'flex':'none', marginTop: '8px', position: 'relative', flexDirection: 'row', justifyContent: 'flex-end'}}>


                        <a href="/signin">
                           <View style={{cursor: 'pointer', marginLeft: '0px', backgroundColor: '#fecc27', width: '130px', height: '44px', justifyContent: 'center', borderRadius: '4px',
                               borderWidth: 1, borderColor: '#fecc27'}}>
                              {i18n.language == 'en' && <Text style={{fontSize: '17px', color: '#000', textAlign: 'center',}}>{`Sign in`}</Text>}
                              {i18n.language == 'fr' && <Text style={{fontSize: '17px', color: '#000', textAlign: 'center'}}>{`Se connecter`}</Text>}
                           </View>
                         </a>

                       {viewportWidth > viewportHeight &&
                          <a href="/signup">
                             <View style={{cursor: 'pointer', marginLeft: '20px', backgroundColor: '#3a64db', width: '130px', height: '44px', justifyContent: 'center', borderRadius: '4px',
                                        borderWidth: 1, borderColor: '#3a64db'}}>
                                 {i18n.language == 'en' && <Text style={{fontSize: '17px', color: '#fff', textAlign: 'center',}}>{`Sign up`}</Text>}
                                 {i18n.language == 'fr' && <Text style={{fontSize: '17px', color: '#fff', textAlign: 'center',}}>{`S'enregistrer`}</Text>}
                             </View>
                           </a>
                         }

                   </div>


                   <div className="main_header_inside_right_1" style={{display: 'none', position: 'relative', width: '346px', flexDirection: 'row', justifyContent: 'flex-end'}}>

                      {uniqueItemsCount > 0 &&
                        <div style={{position: 'absolute', zIndex: 3, left: '38px', backgroundColor: 'red', color: '#fff', fontSize: '16px', fontWeight: 'bold', borderRadius: '13px', minWidth: '32px', height: '26px', lineHeight: '26px', textAlign: 'center'}}>
                           {uniqueItemsCount}
                        </div>
                      }

                       <a href="/cart">
                          <View style={{cursor: 'pointer', marginTop: '5px', width: '44px', height: '44px', justifyContent: 'center'}}>
                             <Image source={{uri: 'https://s3.us-east-1.amazonaws.com/debyooinc20.img/yeqola/cart_empty_white.png'}} style={{width: '44px', height: '44px',}}/>
                          </View>
                        </a>


                        <a href="/signin">
                           <View style={{marginLeft: '40px', marginTop: '5px', backgroundColor: '#fff', width: '120px', height: '44px', justifyContent: 'center', borderRadius: '4px',
                               borderWidth: 1, borderColor: '#fff'}}>
                              {i18n.language == 'en' && <Text style={{fontSize: '17px', color: '#000', textAlign: 'center', fontFamily: 'Mohave',}}>{`Sign in`}</Text>}
                              {i18n.language == 'fr' && <Text style={{fontSize: '17px', color: '#000', textAlign: 'center', fontFamily: 'Mohave',}}>{`Se connecter`}</Text>}
                           </View>
                         </a>

                       <a href="/signup">
                         <View style={{marginLeft: '20px', marginTop: '5px', width: '120px', height: '44px', justifyContent: 'center', borderRadius: '4px',
                                    borderWidth: 1, borderColor: '#fff'}}>
                             {i18n.language == 'en' && <Text style={{fontSize: '17px', color: '#fff', textAlign: 'center', fontFamily: 'Mohave',}}>{`Sign up`}</Text>}
                             {i18n.language == 'fr' && <Text style={{fontSize: '17px', color: '#fff', textAlign: 'center', fontFamily: 'Mohave',}}>{`S'enregistrer`}</Text>}
                         </View>
                      </a>

                   </div>


                   <div className="main_header_inside_right_1" style={{float: 'right', marginTop: 0, color: '#333'}}>
                       <SearchBoxTablet handleSearchChange={handleSearchChange}/>
                   </div>


                   <div style={{clear: 'both'}}/>

                 </div>
             }
      </div>

    )

});

export default HeaderTablet;
